export class ToastService {
  static async getActiveToasts(screenName) {
    try {
      // Add cache-busting timestamp to handle Kubernetes ConfigMap updates
      const cacheBuster = new Date().getTime();
      const response = await fetch(`/toasts.json?v=${cacheBuster}`, {
        cache: "no-cache",
        headers: {
          "Cache-Control": "no-cache, no-store, must-revalidate",
          Pragma: "no-cache",
          Expires: "0",
        },
      });
      const toastConfig = await response.json();
      const now = new Date().toISOString();

      return toastConfig.toasts.filter((toast) => {
        // Check if toast is for this screen
        if (!toast.screens.includes(screenName)) return false;

        // Check if toast has expired
        if (toast.expirationDate && toast.expirationDate < now) return false;

        // Check if toast should only show once and has been dismissed
        if (toast.showOnce && this.hasBeenDismissed(toast.id)) return false;

        return true;
      });
    } catch (error) {
      console.error("Failed to load toasts:", error);
      return [];
    }
  }

  static hasBeenDismissed(toastId) {
    const dismissedToasts = JSON.parse(
      localStorage.getItem("dismissedToasts") || "[]"
    );
    return dismissedToasts.includes(toastId);
  }

  static dismissToast(toastId) {
    const dismissedToasts = JSON.parse(
      localStorage.getItem("dismissedToasts") || "[]"
    );
    if (!dismissedToasts.includes(toastId)) {
      dismissedToasts.push(toastId);
      localStorage.setItem("dismissedToasts", JSON.stringify(dismissedToasts));
    }
  }

  static markAsViewed(toastId) {
    const viewedToasts = JSON.parse(
      localStorage.getItem("viewedToasts") || "[]"
    );
    if (!viewedToasts.includes(toastId)) {
      viewedToasts.push(toastId);
      localStorage.setItem("viewedToasts", JSON.stringify(viewedToasts));
    }
  }

  // Global method to trigger immediate refresh of all toast containers
  static triggerGlobalRefresh() {
    window.dispatchEvent(new CustomEvent("toastConfigUpdated"));
  }

  // Method to clear all dismissed toasts (useful for testing updated configurations)
  static clearDismissedToasts() {
    localStorage.removeItem("dismissedToasts");
    localStorage.removeItem("viewedToasts");
  }
}
